import React, { useState } from 'react';

function getVideoTypeAndUrl(url) {
  if (!url) return null;

  // 1. YouTube
  const ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?/]+)/);
  if (ytMatch) {
    return { type: 'iframe', url: `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1` };
  }

  // 2. Vimeo
  if (url.includes('vimeo.com')) {
    const vMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vMatch) {
      return { type: 'iframe', url: `https://player.vimeo.com/video/${vMatch[1]}?autoplay=1` };
    }
  }

  // 3. Facebook
  if (url.includes('facebook.com') || url.includes('fb.watch')) {
    return { type: 'iframe', url: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0&width=560&autoplay=true` };
  }

  // 4. Instagram
  if (url.includes('instagram.com')) {
    const cleanUrl = url.split('?')[0].replace(/\/$/, '');
    return { type: 'iframe', url: `${cleanUrl}/embed/` };
  }

  // 5. Direct Video File (Amazon S3 / MP4 / etc.)
  const lowerUrl = url.toLowerCase();
  if (
    lowerUrl.endsWith('.mp4') ||
    lowerUrl.endsWith('.webm') ||
    lowerUrl.endsWith('.ogg') ||
    lowerUrl.endsWith('.mov') ||
    lowerUrl.includes('amazonaws.com')
  ) {
    return { type: 'video', url: url };
  }

  return null;
}


function PostModal({ post, onClose, settings }) {
  const [imgIdx, setImgIdx] = useState(0);
  const video = getVideoTypeAndUrl(post.video_url);
  const hasImages = post.images && post.images.length > 0;

  return (
    <div className="post-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="post-modal">

        {/* Media */}
        <div className="post-modal-media">
          {video ? (
            video.type === 'iframe' ? (
              <iframe src={video.url} title={post.title} allow="autoplay" allowFullScreen />
            ) : (
              <video src={video.url} controls autoPlay style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }} />
            )
          ) : hasImages ? (
            <>
              <img src={post.images[imgIdx]} alt={`slide-${imgIdx}`} />
              {post.images.length > 1 && (
                <>
                  <button className="modal-gallery-nav prev" onClick={() => setImgIdx(i => (i - 1 + post.images.length) % post.images.length)}>‹</button>
                  <button className="modal-gallery-nav next" onClick={() => setImgIdx(i => (i + 1) % post.images.length)}>›</button>
                  <div className="modal-dots">
                    {post.images.map((_, i) => <span key={i} className={i === imgIdx ? 'active' : ''} />)}
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ color: '#333', fontSize: '3rem' }}>🎬</div>
          )}
        </div>

        {/* Side */}
        <div className="post-modal-side">
          <div className="post-modal-header">
            <div className="post-modal-avatar">
              {settings?.logo_circular_url
                ? <img src={settings.logo_circular_url} alt="logo" />
                : '🎬'}
            </div>
            <span className="post-modal-username">{settings?.site_title || 'El Popular'}</span>
            <button className="post-modal-close" onClick={onClose}>×</button>
          </div>

          <div className="post-modal-body">
            <h3 style={{ color: '#b81623' }}>{post.title}</h3>
            {post.description && <p style={{ marginTop: '.5rem' }}>{post.description}</p>}
          </div>

          <div className="post-modal-date">
            {new Date(post.created_at).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>

      </div>
    </div>
  );
}

export default function PostCard({ post, settings }) {
  const [open, setOpen] = useState(false);
  const video = getVideoTypeAndUrl(post.video_url);
  const hasImages = post.images && post.images.length > 0;
  const thumb     = hasImages ? post.images[0] : null;

  return (
    <>
      <div className="grid-item" onClick={() => setOpen(true)}>
        {thumb ? (
          <img src={thumb} alt={post.title} />
        ) : video ? (
          video.type === 'video' ? (
            <video src={video.url} muted playsInline style={{ width:'100%', height:'100%', objectFit:'cover' }} preload="metadata" />
          ) : (
            <div style={{ width:'100%', height:'100%', background:'#111', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>▶</div>
          )
        ) : (
          <div style={{ width:'100%', height:'100%', background:'#111', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem' }}>🎬</div>
        )}

        {/* Badge múltiples fotos o video */}
        {hasImages && post.images.length > 1 && (
          <span className="grid-item-badge">⧉</span>
        )}
        {video && (
          <span className="grid-item-badge">▶</span>
        )}

        <div className="grid-item-overlay">
          <span>🎬 {post.title}</span>
        </div>
      </div>

      {open && <PostModal post={post} onClose={() => setOpen(false)} settings={settings} />}
    </>
  );
}
